// Copyright (C) 2017, 2018 DecElite LLC - All Rights Reserved. May not be distributed or copied.
module.exports = [
  { section: 'Privacy',
    qs:      [
      { q: 'Is my data secure?',
        a: `Yes! While you should read our Privacy Policy for full details, every
        effort has been made to ensure that all information your provide us is stored
        and transmitted securely.`,
      },
      { q: 'What do I do if I think my account has been compromised?',
        a: 'Please contact us as soon as you have concerns at support@dartcannon.com',
      },
      { q: 'What type of data do you collect?',
        a: `Full details are in our TOS and Privacy, but in general we only
        collect aggregate statistics.`,
      },
      { q: 'Who can see the details of my simulation?',
        a: `We have both technology and processes to ensure that only the
        owner can access any given simulation and its details.`,
      },
      { q: 'How secure is my payment information?',
        a: `All credit card information is stored by our payment provider,
        Stripe, which manages payments for many companies and has industry
        leading security measures.`,
      },
      { q: 'Can DartCannon employees view details of my simulations?',
        a: `We have policies, procedures, and technologies in place to keep anyone
        from viewing simulations without your expressed permission.`,
      },
      { q: 'If I sign up, how much email will you send?',
        a: `Here's what you can expect: a Welcome Email, an email verification message
        if you opted to use and email and password to sign in, and after that only the
        infrequent major announcement (such as changes to our Privacy Policy or Terms
        of Service)`,
      },
    ],
  },
  { section: 'Pricing & Billing',
    qs:      [
      { q: 'Can I get a rebate if I cancel part way through my subscription?',
        a: 'Unfortunately to avoid fraud, we are unable to offer partial refunds.',
      },
      { q: 'What happens if I let my subscription lapse?',
        a: `If your subscription expires, all of your data is preserved and can still
        be viewed. If you have more simulations than allowed on a free plan, you will
        not be able to create new ones unless you delete enough to be below the limit.
        Similarly, you will not be able to edit any simulation with more items than
        permitted by the free plan.`,
      },
      { q: 'Can I pay using PayPal?',
        a: 'While on our roadmap, we do not support payments through PayPal at this time.',
      },
      { q: 'Can I share an account with coworkers?',
        a: `Sharing accounts among multiple people is prohibited in our TOS and, if
        found, may result in account termination. If you have multiple people at your
        work or company who want to use DartCannon, we do offer bulk discounts and
        site licenses. Contact sales@dartcannon.com for information.`,
      },
    ],
  },
  { section: 'Estimates',
    qs:      [
      { q: 'Can I use distributions other than triangles?',
        a: 'We plan on supporting other distribution types down the road, but at present only support triangular probabilities',
      },
      { q: 'Is it possible to make the probability of a risk a range?',
        a: `Because of how the simulation works, we do not allow probabilities to be
        ranges. Also, uncertainty about uncertainty adds a great deal of additional
        complexity in estimating that is likely not adding value.`,
      },
      { q: 'Aren\'t all estimates a waste of time?',
        a: `Far from it! Estimates can be a valuable tool to help with decision making
        as long as they are interpreted and used appropriately. DartCannon exists
        to help make estimates valuable and capture their inherent uncertainty.`,
      },
    ],
  },
  { section: 'Other',
    qs:      [
      { q: 'I accidentally deleted a simulation - how can I get it back?',
        a: `Contact support (support@dartcannon.com). While we do not retain any
        information you've requested us to delete, we often can recover inadvertently
        lost data from our short-term back-ups.`,
      },
      { q: 'I found a problem or bug - what should I do?',
        a: `Contact support (support@dartcannon.com). While we rigorously run tests,
        no software is perfect and there is always the risk of something having been
        missed.`,
      },
      { q: 'I have a great idea for how DartCannon can be made better - who can I talk to?',
        a: `Contact support (support@dartcannon.com). We have a long and ever growing
        list of improvements and are always happy to add community ideas!`,
      },
      { q: 'I want to delete my account and all simulations',
        a: `We're sorry to see you go, but we understand wanting to keep a small digital
        footprint. Contact support@dartcannon.com and after confirming you identity,
        we'll remove all your information from our systems.`,
      },
    ],
  },
]
